<script>

import timeRemainingMixin from '@/mixins/timeRemainingMixin.js'

export default {
  name: 'TwTimeLeft',
  components: {},
  mixins:[timeRemainingMixin],
  props: {
    deadline: {
      type: [Object, String],
      required: true
    },
    detailed: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      IntervalRepeaterReference: null,
      TimeRemainingString: null,
    }
  },
  beforeMount () {
    this.updateTimeRemaining()
    this.IntervalRepeaterReference = setInterval(this.updateTimeRemaining, 1000)
  },
  beforeUnmount () {
    clearInterval(this.IntervalRepeaterReference)
  },
  methods: {
    updateTimeRemaining() {
      if(this.detailed) {
        this.TimeRemainingString = this.formatTimeLeft(this.timeLeftUntil(this.deadline))
      }
      else {
        this.TimeRemainingString = this.$filters.timeLeft(this.deadline, true)
      }
    }
  }
}
</script>

<template>
  <div class="pt-1">
    <span v-if="prefix" class="font-bold"><slot name="prefix" /></span><span v-html="TimeRemainingString" /> remaining
  </div>
</template>

<style scoped>
/* Animation for hour hand (faster rotation for effect) */


</style>
